<section class="default-section">
  <article class="default-card">
    <div class="card page-jumbotron-card">
      <div class="page-jumbotron">
        <div class="page-jumbotron-image">
          <picture>
            <img [src]="imgPath + '/start/blitzshare-canoe-w500.webp'" alt="Blitzshare" class="jumbotron-image top-rounded-image" />
          </picture>
        </div>

        <div class="page-jumbotron-content">
          <h1 class="jumbotron-headline">Blitzshare</h1>
          <p class="jumbotron-lead">{{ LEAD_BLITZSHARE }}</p>
          <a href="https://blitzshare.de" target="_blank" rel="noreferrer">
            <button color="primary" mat-flat-button>Zu Blitzshare.de</button>
          </a>
        </div>
      </div>
    </div>

    <h1 class="paragraph-headline">Was ist Blitzshare?</h1>

    <p>
      Blitzshare ist eine Plattform, die es ihren Nutzern ermöglicht Gegenstände zum Vermieten anzubieten sowie Gegenstände von anderen
      Nutzern zu mieten. Dabei gibt es keine Beschränkung auf eine bestimmte Kategorie oder Art von Gegenständen. Fast alles ist möglich von
      Sportgeräten über Werkzeuge bis hin zu Hochzeitskleidern.
    </p>
    <p>
      Mit Start im August 2021 trifft Blitzshare voll den Zeitgeist: <span class="highlight-text">Sharing ist Caring</span>,
      <span class="highlight-text">Ressourcen schonen</span> und <span class="highlight-text">Emissionen verhindern</span>. Denn viele Leute
      können sich jetzt beispielsweise einen Bohrhammer teilen, statt für jeden einen eigenen produzieren zu müssen.
    </p>
    <p></p>

    <div class="row">
      <div class="col-md-6">
        <h1 class="paragraph-headline">Gründe auf Blitzshare zu mieten</h1>
        <ul>
          <li>
            <h3 class="paragraph-headline-3">Vor dem Kauf ausprobieren</h3>
            <p>
              Möchtest du eine neue Sportart ausprobieren, aber bist nicht sicher, ob sie dir gefallen wird? Miete die Ausrüstung auf
              Blitzshare und finde es heraus!
            </p>
          </li>

          <li>
            <h3 class="paragraph-headline-3">Geld und Platz sparen</h3>
            <p>
              Hast du schon mal ein Werkzeug gekauft, das du nur einmal gebraucht hast und seitdem liegt es nur herum? Wenn es doch nur eine
              bessere Lösung gäbe...
            </p>
          </li>

          <li>
            <h3 class="paragraph-headline-3">Hilf der Umwelt</h3>
            <p>Teile Dinge mit anderen. Spare wertvolle Ressourcen. Reduziere Abfall. Reduziere Emissionen.</p>
          </li>
        </ul>
      </div>
      <div class="col-md-6">
        <h1 class="paragraph-headline">Gründe auf Blitzshare zu vermieten</h1>
        <ul>
          <li>
            <h3 class="paragraph-headline-3">Geld verdienen</h3>
            <p>
              Besitzt du ein Fahrrad, ein Elektrowerkzeug, ein Kayak, Skiausrüstung oder irgendetwas anderes, was du nicht täglich benutzt?
              Vermiete es und verdiene Geld.
            </p>
          </li>
          <li>
            <h3 class="paragraph-headline-3">Hilf anderen, ihren Leidenschaften zu folgen</h3>
            <p>
              Ermögliche es Menschen Dinge zu tun, die sie sonst nicht tun könnten. Wenn du z.B. in der Nähe eines Sees lebst und ein SUP
              hast, kannst du es an jemanden vermieten, der es sich kein eigenes leisten kann.
            </p>
          </li>

          <li>
            <h3 class="paragraph-headline-3">Neue Leute kennenlernen</h3>
            <p>Wenn jemand deine Waren mietet, habt ihr wahrscheinlich ein gemeinsames Interesse. Vielleicht bleibt ihr ja in Kontakt.</p>
          </li>
        </ul>
      </div>
    </div>

    <h1 class="paragraph-headline">Kategorien auf Blitzshare</h1>

    <p>
      Blitzshare bietet eine Vielzahl an Kategorien, in denen die Nutzer Gegenstände mieten und vermieten können.
      <a href="https://blitzshare.de/de/browse/category" target="_blank" rel="noreferrer">Hier</a> finden Sie die gesamte Liste. Die
      folgenden Bilder vermitteln einen Eindruck von der Vielfalt:
    </p>
    @if (imgUrlsObject.length) {
      <div class="mb-3">
        <div class="carousel-container" id="carouselObject">
          <button (click)="previousImage('carouselObject')" aria-label="Vorheriges Bild" class="carousel-button" mat-icon-button>
            <mat-icon>chevron_left</mat-icon>
          </button>
          <div class="carousel-image" (click)="openImage(activeImageIndexObject, imgUrlsObject)">
            @if (getActiveImage("carouselObject"); as activeImage) {
              <picture>
                <source [srcset]="activeImage.w350" media="(max-width: 350px)" />
                <source [srcset]="activeImage.w500" media="(max-width: 500px)" />
                <source [srcset]="activeImage.w750" media="(max-width: 750px)" />
                <img [alt]="activeImage.title" [src]="activeImage.w1124" />
              </picture>
            }
          </div>
          <button (click)="nextImage('carouselObject')" aria-label="Nächstes Bild" class="carousel-button" mat-icon-button>
            <mat-icon>chevron_right</mat-icon>
          </button>
        </div>
        <div class="thumbnail-container m-0 p-0">
          <app-thumbnail-widget (imgClicked)="selectImage($event.index, 'carouselObject')" [imgUrls]="imgUrlsObject"></app-thumbnail-widget>
        </div>
      </div>
    }
  </article>
</section>
